(function () {
  var root = document.querySelector('[data-vg-popup]');
  if (!root) return;
  if (root.parentNode !== document.body) document.body.appendChild(root);
  var cfg = JSON.parse(root.getAttribute('data-config') || '{}');
  var pop = root.querySelector('.vg-pop');
  var dialog = root.querySelector('.vg-pop__dialog');
  var media = root.querySelector('.vg-pop__media');
  var fab = root.querySelector('.vg-pop-fab');
  var closeBtn = root.querySelector('.vg-pop__close');
  var form = root.querySelector('.vg-pop__form');
  var email = root.querySelector('.vg-pop__input');
  var consent = root.querySelector('.vg-pop__consent input');
  var btn = root.querySelector('.vg-pop__btn');
  var err = root.querySelector('.vg-pop__msg--err');
  var done = root.querySelector('.vg-pop__done');
  var doneText = root.querySelector('.vg-pop__done-text');
  var codeBox = root.querySelector('.vg-pop__code');
  var KEY_DONE = 'vg_popup_done', KEY_DISMISSED = 'vg_popup_dismissed';
  var lastFocus = null, sending = false;
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  if (media) media.style.display = 'block';

  function store(type, k, v) { try { window[type].setItem(k, v); } catch (e) {} }
  function read(type, k) { try { return window[type].getItem(k); } catch (e) { return null; } }
  function isDone() { return read('localStorage', KEY_DONE) === '1'; }

  function showDone(firstTime) {
    form.hidden = true;
    done.hidden = false;
    doneText.textContent = firstTime ? (cfg.emailAuto ? cfg.msgEmail : cfg.msgScreen) : cfg.msgAlready;
    if (codeBox) codeBox.hidden = !firstTime || cfg.emailAuto || !cfg.code;
  }
  function open() {
    if (!pop.hidden) return;
    lastFocus = document.activeElement;
    fab.hidden = true;
    if (isDone() && done.hidden) showDone(false);
    pop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { (form.hidden ? closeBtn : email).focus({ preventScroll: true }); }, 50);
  }
  function close() {
    if (pop.hidden) return;
    pop.hidden = true;
    document.documentElement.style.overflow = '';
    store('sessionStorage', KEY_DISMISSED, '1');
    fab.hidden = isDone();
    if (!fab.hidden) fab.focus({ preventScroll: true });
    else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function fail(msg, field) {
    err.textContent = msg;
    err.hidden = false;
    if (field === email) email.setAttribute('aria-invalid', 'true');
    if (field) field.focus();
  }

  closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
  root.querySelector('.vg-pop__backdrop').addEventListener('click', close);
  fab.addEventListener('click', open);
  document.addEventListener('keydown', function (e) {
    if (pop.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(dialog.querySelectorAll('button, input, a[href]'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  email.addEventListener('input', function () { email.removeAttribute('aria-invalid'); err.hidden = true; });
  if (consent) consent.addEventListener('change', function () { err.hidden = true; });

  var copyBtn = root.querySelector('.vg-pop__copy');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    if (navigator.clipboard) navigator.clipboard.writeText(cfg.code).then(function () { copyBtn.textContent = 'Copié'; });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    var v = email.value.trim();
    email.value = v;
    if (!re.test(v)) return fail(cfg.errInvalid, email);
    if (consent && !consent.checked) return fail(cfg.errConsent, consent);
    sending = true;
    btn.disabled = true;
    btn.textContent = cfg.sending;
    err.hidden = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (res) {
        var url = res.url || '';
        if (url.indexOf('customer_posted=true') !== -1) {
          store('localStorage', KEY_DONE, '1');
          showDone(true);
          fab.hidden = true;
          return;
        }
        if (url.indexOf('/challenge') !== -1) {
          store('sessionStorage', 'vg_popup_pending', '1');
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        throw new Error('rejected');
      })
      .catch(function () { fail(cfg.errServer, email); })
      .finally(function () { sending = false; btn.disabled = false; btn.textContent = cfg.button; });
  });

  var params = new URLSearchParams(location.search);
  if (read('sessionStorage', 'vg_popup_pending') === '1' && params.get('customer_posted') === 'true') {
    try { sessionStorage.removeItem('vg_popup_pending'); } catch (e) {}
    store('localStorage', KEY_DONE, '1');
    showDone(true);
    open();
    return;
  }
  if (isDone()) { fab.hidden = true; return; }
  if (read('sessionStorage', KEY_DISMISSED) === '1') { fab.hidden = false; return; }
  if (cfg.designMode) return;
  setTimeout(function () { if (!isDone() && read('sessionStorage', KEY_DISMISSED) !== '1') open(); }, cfg.delay || 5000);
})();